// Bot que pregunta al dueño y aprende (migración 20261015a_bot_knowledge.sql). Textos y validaciones de la página «Preguntas del bot».

export const MAX_QUESTION = 500;
export const MAX_ANSWER = 1000;

export const questionCode = (q) => `P-${q?.number ?? '?'}`;

// Quién preguntó: el nombre de WhatsApp y el teléfono si el chat lo trae (un ID interno @lid no es un teléfono).
export const customerLabel = (q) => {
  const raw = String(q?.customer_number || q?.customer_jid || '');
  const digits = raw.split('@')[0].replace(/\D/g, '');
  const phone = !raw.endsWith('@lid') && digits.length >= 10 && digits.length <= 15 ? digits : '';
  const name = String(q?.customer_name || '').trim();
  if (name && phone) return `${name} · ${phone}`;
  return name || phone || 'Cliente';
};

const DELIVERY = {
  pendiente: { label: 'Enviando al cliente…', tone: 'text-amber-300' },
  enviando: { label: 'Enviando al cliente…', tone: 'text-amber-300' },
  enviado: { label: 'Enviada al cliente', tone: 'text-emerald-400' },
  error: { label: 'No se pudo enviar al cliente', tone: 'text-rose-300' },
  omitido: { label: 'No se envió al cliente (pregunta de hace más de 3 días)', tone: 'text-seryi-text' }
};
export const deliveryInfo = (q) => DELIVERY[q?.delivery_status] || DELIVERY.omitido;

// Estado del aviso al dueño de una pregunta abierta.
export const notifyInfo = (q) => {
  switch (q?.notify_status) {
    case 'enviado': return { label: 'Aviso enviado a tu WhatsApp', tone: 'text-emerald-400' };
    case 'pendiente': case 'enviando': return { label: 'Avisando a tu WhatsApp…', tone: 'text-amber-300' };
    case 'error': return { label: `No llegó el aviso: ${q.notify_error || 'error de WhatsApp'}`, tone: 'text-rose-300' };
    default: return { label: 'Sin aviso por WhatsApp (configura el número de avisos)', tone: 'text-seryi-text' };
  }
};

export const checkAnswer = (text) => {
  const t = String(text ?? '').trim();
  if (!t) return 'Escribe la respuesta.';
  if (t.length > MAX_ANSWER) return `La respuesta puede tener hasta ${MAX_ANSWER} caracteres.`;
  return null;
};

export const checkKnowledge = ({ question, answer } = {}) => {
  const q = String(question ?? '').trim();
  if (q.length < 3) return 'Escribe la pregunta (mínimo 3 letras).';
  if (q.length > MAX_QUESTION) return `La pregunta puede tener hasta ${MAX_QUESTION} caracteres.`;
  return checkAnswer(answer);
};

// «hace 5 min», «hace 3 h», «hace 2 días»
export const ago = (iso, now = Date.now()) => {
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return '';
  const min = Math.max(0, Math.round((now - t) / 60000));
  if (min < 1) return 'ahora';
  if (min < 60) return `hace ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `hace ${h} h`;
  const d = Math.round(h / 24);
  return `hace ${d} ${d === 1 ? 'día' : 'días'}`;
};
